module.exports = __webpack_public_path__ + "img/wind.0c36076.svg";